<template>
  <div>
    <div class="opt mt-0 position-relative cursor-pointer" @click="openGameOption"
        v-click-outside="onClickOutside">
      <img
        src="../../assets/Svg/ellipse.svg"
        alt=""
      />
      <div class="sub-setting-options edit-event-options" v-if="gameOption">
        <ul class="mb-0 border-bottom-0 pb-0 d-block">
          <li
            class="del-game"
            data-toggle="modal"
            data-target="#exampleModalEdit"
            @click="checkUpdate"
          >
            Edit Game  
          </li>
          <li class="del-game"  @click="callModal()">Scoring </li>
          <li class="del-game" @click="callModalLineup()">Lineup</li>
          <li class="del-game"  @click="deleteGame()">Delete Game</li>
        </ul>
      </div>
    </div>
    <EditGame :singleGame="singleGame" :eventAlertOptions="eventAlertOptions" />
  </div>
</template>

<script>
import EditGame from "../Teams/Games/EditGame.vue";
import axios from "axios";
export default {
  name: "GameOptions",
  components: {
    EditGame,
  },
  data() {
    return {
      gameOption: false,
    };
  },
  props:{
    singleGame: {
        type: Object
    },
    eventAlertOptions: {
      type: Array,
    },
    selectedRoomTeam: {
      type: Object,
    },
  },
  methods: {
    openGameOption(event) {
       event.preventDefault(); // Prevents <router-link> navigation
      event.stopPropagation(); // Stops event bubbling
      this.gameOption = !this.gameOption;
    },
    onClickOutside() {
      this.gameOption = false;
    },
    checkUpdate() {
      this.$root.$emit("checkUpdateGame", this.singleGame);
    },
    callModal() {
      // if (this.singleGame.opponent_flag == null) {
      //   this.$root.$emit("openSelectHomeTeamModal", this.singleGame);
      // } else {
      var combineUrl = this.selectedRoomTeam.id + "-" + this.singleGame.guid;
      const urlToOpen = `/score-game/${combineUrl}`;
      window.location.href = urlToOpen;
      // }
    },
    callModalLineup: function() {
      this.$root.$emit("openTeamLineUpModal", this.singleGame);
    },
    async deleteGame() {
      this.$confirm(
        "About to remove this game. Continue ?",
        "Remove Game."
      ).then(() => {
        var formData = new FormData();
        formData.append("id", this.singleGame.id);

        axios
          .post(process.env.VUE_APP_API_URL + "game/delete", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            this.$root.$emit("showGameList");
            this.$root.$emit("showEventPageGames");
            
          });
      });
    },
  },
};
</script>